function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Vrstva_4"
}, React.createElement("path", {
  d: "M502.617,205.504c-120.139,0.448-217.161,98.201-216.713,218.334 c0.45,120.134,219.162,381.594,219.162,381.594s216.331-263.087,215.885-383.221C720.498,302.078,622.747,205.057,502.617,205.504z M501.168,542.391c-68.557,0-124.133-55.577-124.133-124.134s55.576-124.134,124.133-124.134 c68.559,0,124.135,55.576,124.135,124.134S569.727,542.391,501.168,542.391z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1006px",
    height: "1006px",
    viewBox: "0 0 1006 1006",
    enableBackground: "new 0 0 1006 1006",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/custom-prevadzky.3e821083.svg";
export { SvgComponent as ReactComponent };